import { Platform } from "react-native";

import { space } from "@/design/tokens";

export const APP_HEADER_CONTROL_HEIGHT = 34;
const WEB_DESIGNED_TOP_PADDING = 40;
const DESIGNED_BOTTOM_PADDING = space.xxl;

/**
 * Native headers frame their controls symmetrically inside the safe area:
 * one 32px designed gutter above and below. The system top inset sits outside
 * that visual frame. Web keeps its intentionally roomier 40px top gutter.
 * Content, mask, and Android backdrop scrim all resolve from this geometry.
 */
export function getAppHeaderVerticalPadding(topInset: number) {
  if (Platform.OS === "web") {
    return {
      paddingBottom: DESIGNED_BOTTOM_PADDING,
      paddingTop: WEB_DESIGNED_TOP_PADDING
    };
  }

  return {
    paddingBottom: DESIGNED_BOTTOM_PADDING,
    paddingTop: topInset + DESIGNED_BOTTOM_PADDING
  };
}

export function getAppHeaderHeight(topInset: number) {
  const { paddingBottom, paddingTop } = getAppHeaderVerticalPadding(topInset);
  return paddingTop + APP_HEADER_CONTROL_HEIGHT + paddingBottom;
}
